import apiUtil from './apiUtil';
import {importAll} from '@/config/customize.js';

const map = importAll(require.context('./', true, /\.js$/));
let arr = {};
for (const [key, value] of map.entries()) {
  if (key) {
    arr = Object.assign({}, arr, value.default);
  }
}

const generateApiMap = apiUtil.generateApiMap({
  ...arr,
});
export default {
  ...generateApiMap, // 取出所有可遍历属性赋值在新的对象上
};



// WEBPACK FOOTER //
// ./src/api/index.js